import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskPracticeNewRoute: InvariantJiraRoute = {
	name: 'servicedesk-practice-new',
	path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/new',
	query: ['parentId?'],
	exact: true,
};
